export default "__VITE_ASSET__22ncEesv__"